import ServiceMainApi from "@/services/v2/service-main-api/ServiceMainApi";
import {plainToInstance} from "class-transformer";
import ModelTransfer from "@models/v2/transfer/ModelTransfer";
import PurchaseOperation from "@models/operations/PurchaseOperation";

export default class RepositoryTransfers {
	public async fetchTransferList() {
		const {data} = await ServiceMainApi.of().get<{ data: Record<string, any>[] }>('/api/mobile/client/transfer-service/list');

		return data.map((item) => this.plainToModel(item));
	}

	public async createTransfer(amount: number, clientId: number) {
		const { data } = await ServiceMainApi.of().post<{ data: Record<string, any>}>(`/api/mobile/client/transfer-service/${clientId}/create`, {
			amount,
		});
		return plainToInstance(PurchaseOperation, data, {
			excludeExtraneousValues: true,
				excludePrefixes: ['_']
		})
	}

	private plainToModel(data: object): ModelTransfer {
		return plainToInstance(ModelTransfer, data, {
			excludeExtraneousValues: true,
			excludePrefixes: ['_']
		});
	}
}
